"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signatureCheck = exports.httpRequest = void 0;
var core_1 = require("@uip-alpha/core");
var http_h5_1 = require("@uip-alpha/http-h5");
var config_1 = require("./config");
core_1.default.use(http_h5_1.default);
var wx = require('./weixin-js-sdk');
// 请求
exports.httpRequest = function (requestParams, signUrl) {
    if (!(requestParams && requestParams.url))
        return Promise.reject({ errorMsg: 'request url must' });
    if (requestParams && requestParams.method === 'post') {
        return core_1.default.http.post(__assign({ data: { url: signUrl } }, requestParams));
    }
    return core_1.default.http.get(__assign({ params: { url: signUrl } }, requestParams));
};
/**
 * 单独的url进行签名配置
 */
exports.signatureCheck = function (signUrl, requestParams, apiList) {
    return new Promise(function (resolve, reject) {
        exports.httpRequest(requestParams, signUrl)
            .then(function (r) {
            var _a = r.data, appId = _a.appId, timestamp = _a.timestamp, nonceStr = _a.nonceStr, signature = _a.signature, obj = _a.obj;
            wx.config({
                // 开启调试模式,调用的所有api的返回值会在客户端alert出来
                // 若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                debug: false,
                appId: appId || (obj === null || obj === void 0 ? void 0 : obj.appId),
                timestamp: timestamp || (obj === null || obj === void 0 ? void 0 : obj.timestamp),
                nonceStr: nonceStr || (obj === null || obj === void 0 ? void 0 : obj.nonceStr),
                signature: signature || (obj === null || obj === void 0 ? void 0 : obj.signature),
                jsApiList: apiList || config_1.jsApiList,
                openTagList: config_1.openTagList // 可选，需要使用的开放标签列表
            });
            wx.ready(function () {
                ;
                (window || global).UIP_WX = wx;
                return resolve({});
            });
            wx.error(function (res) {
                return reject(res);
            });
        })
            .catch(function (error) {
            return reject(error);
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/wxapp-sdk/dist/signature-check.js
// module id = n/XX
// module chunks = 1